import type { FC } from 'react';
import { BuilderTooltip } from '../BuilderTooltip';
import type { SearchableSelectOption } from './searchable-select';

interface SearchableSelectOptionButtonProps {
  option: SearchableSelectOption;
  onSelect: (optionId: string) => void;
}

export const SearchableSelectOptionButton: FC<SearchableSelectOptionButtonProps> = ({
  option,
  onSelect,
}) => (
  <BuilderTooltip label={option.label} description={option.description} side="right">
    <button type="button" onClick={() => onSelect(option.id)}>
      {option.label}
    </button>
  </BuilderTooltip>
);
